import { ButtonLeft } from '@zoopla-eng/zds-components/button';
import { Spinner } from '@zoopla-eng/zds-components/icons';
import { useContext } from 'react';
import { SearchBarContext } from './SearchBar';
import { SearchMedium } from '@zoopla-eng/zds-components/icons';

export const SearchButton = () => {
    const { handleSearchProperties, isLoading } = useContext(SearchBarContext);

    return (
        <ButtonLeft
            category="primary"
            onClick={() => handleSearchProperties?.({ forceUpdate: true })}
            data-testid="search-button"
            Icon={isLoading ? Spinner : SearchMedium}
            fw
        >
            Search
        </ButtonLeft>
    );
};
